export { AttributesForm } from "./AttributesForm";
export { AttributeField } from "./AttributeField";
export { CommonAttributeIcon } from "./CommonAttributeIcon";
export { RelationAttributeInput } from "./RelationAttribute";
export { useCompanyAttributes, useAllAttributes } from "./hooks/useCompanyAttributes";
export { useDealAttributes } from "./hooks/useDealAttributes";
export { useDefaultAttributeValues } from "./hooks/useDefaultAttributeValues";
export { useCommonAttributeSync } from "./hooks/useCommonAttributeSync";
export {
  filterAttributesForCompany,
  filterAttributesForDeal,
  getCommonAttributeIds,
  filterAndProcessAttributeValues,
  attributeValueToFormValue,
  generateDefaultAttributeFieldValues,
  getAttributeValueUpdates,
  validateAttributeValue,
} from "./utils";
export { isRelationAttribute } from "./constants";
// Only the helpers the wider app needs; the rest stay internal to ./RelationAttribute.
export { haveSameRelations, toRelationObjectPayloads } from "./RelationAttribute/utils";
